import * as Constants from "Data/Constants";
import * as HLF from "html-living-framework";

export default class PausePopup extends HLF.Popup {
    /** @override */
    public init(pSize: PIXI.Point) {
        super.init(pSize);
        this.buttonMode = true;
        this.addChild(HLF.PixiUtils.makeText("Paused", Constants.FONT_GEL_MED_35, 35, HLF.Colour.WHITE.toHex()));
        this.blackout?.on(HLF.Input.Events.TAP, this.OnBlackoutClicked.bind(this));
    }

    /** @inheritdoc */
    protected AnimateIn(pCallback: () => void): void {
        pCallback();
    }

    /** @inheritdoc */
    protected AnimateOut(pCallback: () => void): void {
        pCallback();
    }

}
